
import { TrustAPI } from "@/shared/modules/trust-api";
import store from "@/trust-admin-app/store";
import { EventEmitter } from "events";
import {Inject, Options, Vue} from "vue-property-decorator";
import AddEditCorrespondenceModal from "./add-edit-correspondence-modal/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import { CorrespondenceView, PracticeView } from "@/shared/modules/typescript-trustapi-client/models";

@Options({
  components: {
    AddEditCorrespondenceModal,
    LoadingIndicator,
    ErrorIndicator
  },
  mixins: [FormatDateTimeMixin]
})
export default class PracticeCorrespondence extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private correspondenceHeadings = [
    { text: 'Type', value: 'type', sortable: false },
    { text: 'Date received', value: 'dateReceived', sortable: false },
    { text: 'Description', value: 'description', sortable: false },
    { text: 'Filename', value: 'filename', sortable: false },
    { text: 'Action', value: 'actions', sortable: false }
  ];

  private showCorrespondenceModal = false;
  private correspondences: CorrespondenceView[] = [];
  private selectedCorrespondence: CorrespondenceView = null as any;

  private loadingContent = false;
  private errorLoadingContent = false;

  // private addInvestigations(): void {
  //   const investigation: InvestigationView = {
  //     id: null,
  //     practice: this.selectedPractice
  //   };
  //   this.eventCtrl.emit('showAddEditInvestigationModal', investigation);
  // }

  created(): void {
    this.getCorrespondence();
  }

  mounted() {
    this.eventCtrl.on('reload-practice-correspondence', this.getCorrespondence);
  }

  beforeUnmount() {
    this.eventCtrl.off('reload-practice-correspondence', this.getCorrespondence);
  }

  private openAddEditCorrespondence(c: CorrespondenceView): void {
    this.selectedCorrespondence = c;
    this.selectedCorrespondence.practiceId = this.selectedPractice.id;
    this.showCorrespondenceModal = true;
  }

  private closeAddEditCorrespondence(): void {
    this.selectedCorrespondence = null as any;
    this.showCorrespondenceModal = false;
  }

  private async getCorrespondence(): Promise<void> {
    try {

      this.loadingContent = true;
      this.errorLoadingContent = false;
      const resp: any = await this.apiService.CorrespondenceApi?.apiV2CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet(
        this.selectedPractice.id,
      );

      this.correspondences = resp.data.data as CorrespondenceView[];

    } catch (err) {
      this.errorLoadingContent = true;
    } finally {
      this.loadingContent = false;
    }
  }

  private async downloadFile(c: CorrespondenceView): Promise<void> {

    try {
      const resp: any = await this.apiService.CorrespondenceApi?.apiV2CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet(
        c.id,
        { responseType: 'blob' }
      );
      console.log(resp);
      const blob = new Blob([resp.data], {type: resp.headers['content-type']});
      const documentURL = window.URL.createObjectURL(blob);
      const downloadLink = document.createElement('a');
      const fileName = c.file.fileName;
      downloadLink.href = documentURL;
      downloadLink.download = fileName;
      downloadLink.click();
    } catch (err) {
      console.log(err);
    }
  }

  get eventCtrl(): EventEmitter {
   return store.getters.getEventController;
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

}

